import { CodeType } from './CodeType';
import {
  CodeSample,
  BackendNodeJsSample,
  BackendPythonSample,
  BackendPhpSample,
  BackendGoSample,
  BackendCurlSample,
  BackendPostmanSample,
  FrontendAngularSample,
  FrontendJavascriptSample,
  FrontendNextJsSample,
  FrontendReactSample,
  FrontendRemixSample,
  FrontendNuxt3Sample,
  FrontendVuesample,
  MobileAndroidSample,
  MobileIosSample,
  MobileReactNativeSample,
  BackendLaravelSample,
  BackendDotNetSample
} from './samples';

export { CodeType };

export const CodeSamples: CodeSample[] = [
  // BE
  new BackendNodeJsSample(),
  new BackendPythonSample(),
  new BackendLaravelSample(),
  new BackendPhpSample(),
  new BackendGoSample(),
  new BackendCurlSample(),
  new BackendDotNetSample(),
  new BackendPostmanSample(),
  // FE
  new FrontendReactSample(),
  new FrontendRemixSample(),
  new FrontendNuxt3Sample(),
  new FrontendAngularSample(),
  new FrontendVuesample(),
  new FrontendJavascriptSample(),
  new FrontendNextJsSample(),
  // Mobile
  new MobileAndroidSample(),
  new MobileIosSample(),
  new MobileReactNativeSample()
];
